import { adminFetch } from "./_client";
import type { DashboardStats, ChartData, DashboardStatusSummary, PendingValuation } from "./types";


export function fetchPendingValuations(token: string, page = 1) {
  return adminFetch<{ listings: PendingValuation[]; total: number; page: number; limit: number }>(`/admin/valuations/pending?page=${page}`, token);
}


export function reviewValuation(token: string, carId: number, action: "approve" | "reject", expectedUpdatedAt: string, insured_value?: number, reason?: string) {
  return adminFetch<{
    success: boolean;
    action: string;
    valuation_status: string;
    activated: boolean;
    already_active: boolean;
    activation_blockers: string[];
    renew_host_consent: boolean;
  }>(`/admin/valuations/${carId}/review`, token, {
    method: "POST",
    body: JSON.stringify({ action, insured_value, reason, expected_updated_at: expectedUpdatedAt }),
  });
}


export function fetchDashboardStats(token: string) {
  return adminFetch<DashboardStats>("/admin/dashboard/stats", token);
}


export function fetchDashboardCharts(token: string) {
  return adminFetch<ChartData>("/admin/dashboard/charts", token);
}


export function fetchDashboardStatusSummary(token: string) {
  return adminFetch<DashboardStatusSummary>("/admin/dashboard/status-summary", token);
}
